<template>
    <div class="scroll-wrapper" >
        <div class="d-flex" :id="id"
             :class=" hasScroll ?  '': 'justify-content-lg-center' ">
            
            <div class="text-center text-invalid" v-if="sections.length === 0">{{$t("REPORTS.NO_SECTIONS")}}</div>
            <div v-else>
                <div v-if="siloDetails">
                    <div class="d-none d-md-inline">
                    <div class="d-flex justify-content-left">
                        <div class="mt-3 mr-5">
                        <!-- <button type="button" class="btn btn-primary" @click="showModal">
                            {{$t('COMMON.MOISTURE')}}
                        </button>
                        -->
                            <el-button type="primary" @click="showModal">{{$t("COMMON.SILO_DETAILS")}}</el-button>
                        </div>
                    </div>
                </div>

                <div class="d-sm-inline d-md-none d-lg-none">
                    <div class="d-flex justify-content-left">
                        <div class="mt-3 mr-5">
                            <el-button type="primary" @click="showModalMini">{{$t("COMMON.SILO_DETAILS")}}</el-button>
                        </div>
                    </div>
                </div>
                </div>
                



                <div class="d-flex justify-content-center">
                    <div class="mt-3 mr-5">
                        <div>{{$t('COMMON.TEMPERATURE')}}</div>
                        <div>{{$t('COMMON.CO2')}}</div>
                        <!-- <div>{{$t('COMMON.HUMIDITY')}}</div> -->
                    <div class="text-nowrap">{{$t('COMMON.MOISTURE')}}</div>
                </div>
                
               <!-- <div class="d-flex">-->

                <div class="d-none d-md-inline">
                    <div 
                        :class="backgroundEntireSiloColor(silo.status,1)">
       
                        <span :class="backgroundTextSiloColor('temp',silodata['temp'])"
                              class="pt-3">{{buildTextSilo("temp",silodata['temp'])}}
                        </span>

                        <span :class="backgroundTextSiloColor('co2',silodata['co2'])">
                            {{buildTextSilo("co2",silodata['co2'])}}
                        </span>

                        <span :class="backgroundTextSiloColor('moisture',silodata['moisture'])">
                            {{buildTextSilo("moisture",silodata['moisture'])}}
                        </span>

                    </div>
                </div>
                <div class="d-sm-inline d-md-none d-lg-none">
                        <div 
                        :class="backgroundEntireSiloColor(silo.status,0)">
                        
                        <span :class="backgroundTextSiloColor('temp',silodata['temp'])"
                              class="pt-3">{{buildTextSilo("temp",silodata['temp'])}}
                        </span>

                        <span :class="backgroundTextSiloColor('co2',silodata['co2'])">
                            {{buildTextSilo("co2",silodata['co2'])}}
                        </span>

                        <span :class="backgroundTextSiloColor('moisture',silodata['moisture'])">
                            {{buildTextSilo("moisture",silodata['moisture'])}}
                        </span>
                        
                        </div>    
                        
                </div>
            </div> 
        </div>
    </div>
    <modal-component/> 
    <modal-component-mini/> 
        <div>
            <hr>
        </div>
    </div>

</template>

<script>
    import api from "../../utils/api/api";
    import unitConverter from "../../utils/unitConverter";
    //import languageSelector from "../common/languageSelector";
    import dateFormater from "../../utils/dateFormater";
    //import VueModal from '@kouts/vue-modal';
    import '@kouts/vue-modal/dist/vue-modal.css';
    //import Modal from "./Modal";
    import ModalComponent from './Modal.vue';
    import ModalComponentMini from './ModalMini';
   
    

    const DAY_IN_SECS = 60 * 60 * 24;
    export default {
        name: "entireSiloImg",
        components: {
            ModalComponent,   
            ModalComponentMini         
        },
        props: {
            id: {
                required: true,
                type: String
            },
            siteId: {
                required: true,
                type: String
            },
            date: {
                required: true,
                type: Date
            },
            siloName: {
                type: String,
                required: false,
            },
            siloType: {
                type: String,
                required: false,
            },

            siloColor :
            {
                required: true,
                type: Boolean
            },
            siteName:
            {
                required: true,
                type: String
            }
        },
        data: function () {
            return {
                pendingSectionResult: [],
                sections: [],
                loadingInstance: undefined,
                silo: undefined,
                limits: undefined,
                today: new Date(),
                TWO_DAYS_IN_MILLIS: 172800000,
                hasScroll: false,
                langsel:  undefined,
                silodata: [],
                silostatus: undefined,
                dispSmallSilo: undefined,
                //showModal: false,
                detailsDate: undefined,
                detailsSiteId: undefined,
                detailsId: undefined,
                detailsSiloColor: undefined,
                detailssiloName: undefined,
                detailsType: undefined,
                detailsSiteName: undefined,
                siloDetails: this.$store.state.viewDetails
                }
        },     
        mounted: function () {
            this.getSiloFromId(this.siteId, this.id);
            this.detailsId = this.id;
            this.detailsSiteId = this.siteId;
            this.detailsSiloColor = this.siloColor;
            this.detailsDate = this.date;
            this.detailssiloName = this.siloName;
            this.detailsType = this.siloType;
            this.detailsSiteName = this.siteName;

            //console.log("ID, Site, Color, Type: ",this.detailsId,this.detailsSiteId,this.detailsSiloColor,this.detailsType);
            //this.Id = newVal;
        },
        computed: {
            sectionQuantity() {
                if (this.silo === undefined || this.silo.sections === undefined) {
                    return 0;
                }
                return this.silo.sections.length;
            },

        },
        watch: {
            id: function (newVal) {
                this.getSiloFromId(this.siteId, newVal);
                this.detailsId = newVal;
                //console.log("detailsId: "+this.detailsId);
            },
            date: function (newVal) {
                //this.sections = new Array(this.sectionQuantity);
                //this.loadSections(this.sectionQuantity, this.siteId, this.id, newVal.getTime() / 1000);
                //this.datenew = newVal;
            },
            siloColor: function(newVal)
            {
                //console.log("siloColor: "+newVal);  
                this.getSiloFromId(this.siteId, this.id);
                this.detailsSiloColor = newVal;
            },
            siteId: function(newVal){
                //this.SiteId = newVal;
            },
            pendingSectionResult: function (newVal) {
                let pending = newVal.filter(value => {
                    return (value.awaiting === undefined || value.awaiting);
                });

                if (pending.length !== 0 && this.loadingInstance === undefined) {
                    this.loadingInstance = this.$loading({target: document.getElementById(this.id)});
                }
                if (pending.length === 0) {
                    for (let i = 0; i < newVal.length; i++) {
                        this.sections.splice(i, 1, newVal[i].data)
                    }
                    if (this.loadingInstance) {
                        this.loadingInstance.close();
                        this.loadingInstance = undefined;
                    }
                    this.setScroll();
                }

            }
        },
        methods: {
            setScroll() {
                setTimeout(() => {
                    let div = document.getElementById(this.id);
                    if (div === undefined || div === null) {
                        return false;
                    }

                    this.hasScroll = div.scrollWidth > div.offsetWidth
                }, 200)

            },
            getSiloFromId(siteId, siloId) {
                api.getSilo(siteId, siloId).then(value => {
                    this.silo = value.silo;
                    api.getGrainAlertThresholds(this.silo.type).then(limits => {
                        this.limits = limits.limits;
                    });

                    const size = this.silo.sections !== undefined ? this.silo.sections.length : 0;
                    //this.loadSections(size, siteId, siloId, this.date.getTime() / 1000);
                    this.sections = this.silo.sections;
                    this.silodata = this.silo.promdata;
                    this.silostatus = this.silo.status;

                }).catch(reason => {
                    console.error("Error al traer el silo", reason);
                })

            },
            convertIndex(type)
            {
                 let indice;
                //Rebautizamos los tipos para no cambiar todo
                switch(type)
                {
                    case "temp":
                        indice = "temp";
                    break;

                    case "hum":
                        indice = "hum";
                    break;

                    case "co2":
                        indice = "CO2";
                    break;
                    
                    case "moisture":
                        indice = "hum_grano";
                    break;

                    default: //Tipo invalido, retornamos no data
                    return false;
                }
                return indice;
            },
            /*buildText(type, value) {
                if (value && value.length > 0 && value[value.length - 1]) {
                    return unitConverter.convertTo(type, value[value.length - 1][type], this.$store.getters.unit(type)) + " " + this.$store.getters.unit(type);
                } else {
                    return this.$t("REPORTS.NO_DATA");
                }
            },
            */
            buildText(type,value)
            {
                let indice;

                indice = this.convertIndex(type);
                if(indice === false)
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                if(!value)
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                if(!value[indice])
                {
                    return this.$t("REPORTS.NO_DATA");
                }

                return unitConverter.convertTo(type,value[indice], this.$store.getters.unit(type)) + " " + this.$store.getters.unit(type);
               

            },
            buildTextSilo(type,value)
            {
                
                if(value === false)
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                if(!type)
                {
                    return this.$t("REPORTS.NO_DATA");
                }
                
                if(isNaN(value))
                {
                    return "-";                    
                } 

                return unitConverter.convertTo(type,value, this.$store.getters.unit(type)) + " " + this.$store.getters.unit(type);


            },
            loadSections(size, siteId, SiloId, from) {
                this.pendingSectionResult = new Array(size);
                for (let i = 0; i < size; i++) {
                    this.pendingSectionResult.splice(i, 1, {awaiting: true, data: []});
                    api.getHistorics(siteId, SiloId, i + 1, from, from + DAY_IN_SECS).then(value => {
                        this.pendingSectionResult.splice(i, 1, {awaiting: false, data: value.history});
                    }).catch(reason => {
                        this.pendingSectionResult.splice(i, 1, {awaiting: false, data: []});
                    });
                }
            },
            backgroundColor(type, section) {

                let backgroundClasses = ["no_data", "ok", "warn", "danger", "none", "disabled"];
                if (section === undefined) {
                    return "";
                }

                return "background-image-container__image--" + backgroundClasses[this.getStatus(type, section)];
            },
            backgroundTextSiloColor(type,value) {
                let backgroundClasses = ["no_data", "ok", "warn", "danger", "none", "disabled"];
                if (value === undefined) {
                    return "";
                }
                return "background-image-container__image--" + backgroundClasses[this.getStatusTextSilo(type, value)];
            },
            getStatusColor(status)
            {
               // return " ";

                if(!status)
                {
                    return " ";
                }
                switch (status)
                {
                    case 1:
                    return "-green ";
                    
                    case 2:
                    return "-yellow ";

                    case 3:
                    return "-red ";
                }

                return " ";
            },
            backgroundSiloColor(position,section)
            {
                let classStart = "background-image-container background-image-container__";
                let classEnd = undefined;
                let color = " ";

                switch(position)
                {
                    case "left":
                        classEnd = "align-items-end";
                    break;

                    case "center":
                        classEnd = "";
                    break;

                    case "right":
                        classEnd = "align-items-start"
                    break;
                    
                }
                if(this.siloColor)
                {
                    color = this.getStatusColor(section["status"]);
                }
                

                return classStart + position + "-border-image" + color + classEnd;
            },
            backgroundEntireSiloColor(status,size)
            {
                let classStart = "background-silo-image-container background-silo-image-container__";
                let siloimg = undefined;
                let color = " ";

                if(size === 1)
                {
                    siloimg = "entire-large-image";
                }
                else
                {
                    siloimg = "entire-short-image";
                }
                
                if(this.siloColor)
                {
                    color = this.getStatusColor(status);
                }
                //let siloimg = "entire-short-image";
                return classStart + siloimg + color;
            },
            getStatus(type, section) {
                if (section) 
                {
                    //console.log("Indice: "+indice);

                    let data = section;
                    let indice = this.convertIndex(type);
                    //console.log("Type: "+type);
                    if(!type)
                        return 0;

                    if (this.limits === undefined || this.limits[type] === undefined || data[indice] === undefined) {
                        return 0;
                    }
                    let status;
                    //delete data.date;

                    const value = unitConverter.convertTo(type, data[indice], this.$store.getters.unit(type));
                    const A = unitConverter.convertTo(type, this.limits[type].status[2].min_end, this.$store.getters.unit(type));
                    const B = unitConverter.convertTo(type, this.limits[type].status[0].min_start, this.$store.getters.unit(type));
                    const C = unitConverter.convertTo(type, this.limits[type].status[0].max_end, this.$store.getters.unit(type));
                    const D = unitConverter.convertTo(type, this.limits[type].status[2].max_start, this.$store.getters.unit(type));

                    if (value < A || value > D) {
                        status = 3;
                    } else if (value > A && value < B) {
                        status = 2;
                    } else if (value > B && value < C) {
                        status = 1;
                    } else if (value > C && value < D) {
                        status = 2;
                    }

                    return status;
                }
                return 0;
            },
            getStatusTextSilo(type,data) {
                if (data) 
                {
                    //console.log("Indice: "+indice);

                    //console.log("Type: "+type);
                    //console.log("Value: "+data);

                    if(!type)
                        return 0;

                    if (this.limits === undefined || this.limits[type] === undefined || data === undefined) {
                        return 0;
                    }

                    if(isNaN(data))
                    {
                        return 0;
                    }

                    let status;
                    //delete data.date;

                    const value = unitConverter.convertTo(type, data, this.$store.getters.unit(type));
                    const A = unitConverter.convertTo(type, this.limits[type].status[2].min_end, this.$store.getters.unit(type));
                    const B = unitConverter.convertTo(type, this.limits[type].status[0].min_start, this.$store.getters.unit(type));
                    const C = unitConverter.convertTo(type, this.limits[type].status[0].max_end, this.$store.getters.unit(type));
                    const D = unitConverter.convertTo(type, this.limits[type].status[2].max_start, this.$store.getters.unit(type));

                    if (value < A || value > D) {
                        status = 3;
                    } else if (value > A && value < B) {
                        status = 2;
                    } else if (value > B && value < C) {
                        status = 1;
                    } else if (value > C && value < D) {
                        status = 2;
                    }

                    return status;
                }
                return 0;
            },
            isOldDate(date) {
                return this.today.getTime() - this.TWO_DAYS_IN_MILLIS > new Date(date).getTime()
            },
            formatDate(date) {
                return dateFormater.dateFormat(date,this.$store.state.language);
            },
            showModal()
            {
                this.$modal.show('modal-component',
                    {
                        siteid: this.detailsSiteId,
                        siloid: this.detailsId,
                        silocolor: this.detailsSiloColor,
                        date: this.detailsDate,
                        siloname: this.detailssiloName,
                        silotype: this.detailsType,            
                        siteName: this.detailsSiteName,                       
                    }
                );
            },
            showModalMini()
            {
                this.$modal.show('modal-component-mini',
                    {
                        siteid: this.detailsSiteId,
                        siloid: this.detailsId,
                        silocolor: this.detailsSiloColor,
                        date: this.detailsDate,
                        siloname: this.detailssiloName,
                        silotype: this.detailsType,            
                        siteName: this.detailsSiteName,
                    }
                );
            }
            /*toggleModal: function() {
                this.showModal = false;
            }
            */

        }

    }
</script>

<style lang="scss">
    @import '~bootstrap/scss/_functions';
    @import '~bootstrap/scss/_variables';
    @import '~bootstrap/scss/mixins/_breakpoints';
    @import '~animate.css/animate.css';

    $siloColor: #6ac9d711;
    $siloRed: #fcc3b8;
    $siloYellow: rgb(255, 255, 140) ;
    $siloGreen: rgb(184, 243, 66);

    .silo-img {
        height: 100px;
    }

    .scroll-wrapper {
        overflow-x: visible;
        overflow-y: hidden;
    }

    .background-image-container {
        height: 100px;
        width: 100px;

        background-size: cover;
        background-repeat: no-repeat;
        background-position: right top;
        background-attachment: scroll;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        &__left-border-image {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloColor;
        }
        
        &__left-border-image-green {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloGreen;
        }

        &__left-border-image-yellow {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloYellow;
        }

        &__left-border-image-red {
            mask: url("../../assets/images/silo/greyLeft.svg");
            background: $siloRed;
        }


        &__right-border-image {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloColor;
            margin-left: 0.5em;
        }

       &__right-border-image-green {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloGreen ;
            margin-left: 0.5em;
        }

       &__right-border-image-yellow {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloYellow ;
            margin-left: 0.5em;
        }

       &__right-border-image-red {
            mask: url("../../assets/images/silo/greyRight.svg");
            background: $siloRed ;
            margin-left: 0.5em;
        }


        &__center-border-image {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloColor;
            margin-left: 0.5em;
        }

        &__center-border-image-green {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloGreen;
            margin-left: 0.5em;
        }
        
        &__center-border-image-yellow {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloYellow;
            margin-left: 0.5em;
        }

        &__center-border-image-red {
            mask: url("../../assets/images/silo/greyCenter.svg");
            background: $siloRed;
            margin-left: 0.5em;
        }

        &__entire-large-image {
            mask: url("../../assets/images/silo/greyEntireLarge.svg");
            margin-left: 0.5em;
        }

        &__entire-short-image {
            mask: url("../../assets/images/silo/greyEntireShort.svg");
            margin-left: 0.5em;
        }


        &__image {
            &--no_data {
                color: #727272;
            }

           /* &--ok {
                color: #37B34A;
                opacity: 0.6;
            }

            &--warn {
                color: #ffb400;
                opacity: 0.6
            }

            &--danger {
                color: #c4183c;
                opacity: 0.6;
            }
            */
            &--ok {
                color: rgb(32, 114, 44);
                opacity: 0.6;
            }

            &--warn {
                color: #c08600;
                opacity: 0.6
            }

            &--danger {
                color: #c4183c;
                opacity: 0.6;
            }
            
            &--none {
                color: #ccc;
            }

            &--disabled {
                color: black;
            }
        }


    }



 .background-silo-image-container {
        height: 100px;
        //width: 723px;

        background-size: cover;
        background-repeat: no-repeat;
        background-position: right top;
        background-attachment: scroll;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

    
        &__entire-large-image {
            width: 723px;
            mask: url("../../assets/images/silo/greyEntireLarge.svg");
            background: $siloColor;
            margin-left: 0.5em;
        }

        &__entire-short-image {
            width: 443px;
            mask: url("../../assets/images/silo/greyEntireShort.svg");
            background: $siloColor;
            margin-left: 0.5em;
        }

        &__entire-large-image-red {
            width: 723px;
            mask: url("../../assets/images/silo/greyEntireLarge.svg");
            background: $siloRed;
            margin-left: 0.5em;
        }

        &__entire-short-image-red {
            width: 443px;
            mask: url("../../assets/images/silo/greyEntireShort.svg");
            background: $siloRed;
            margin-left: 0.5em;
        }


        &__entire-large-image-green {
            width: 723px;
            mask: url("../../assets/images/silo/greyEntireLarge.svg");
            background: $siloGreen;
            margin-left: 0.5em;
        }

        &__entire-short-image-green {
            width: 443px;
            mask: url("../../assets/images/silo/greyEntireShort.svg");
            background: $siloGreen;
            margin-left: 0.5em;
        }

        &__entire-large-image-yellow {
            width: 723px;
            mask: url("../../assets/images/silo/greyEntireLarge.svg");
            background: $siloYellow;
            margin-left: 0.5em;
        }

        &__entire-short-image-yellow {
            width: 443px;
            mask: url("../../assets/images/silo/greyEntireShort.svg");
            background: $siloYellow;
            margin-left: 0.5em;
        }


        &__image {
            &--no_data {
                color: #727272;
            }
            &--ok {
                color: rgb(32, 114, 44);
                opacity: 0.6;
            }

            &--warn {
                color: #c08600;
                opacity: 0.6
            }

            &--danger {
                color: #c4183c;
                opacity: 0.6;
            }
            
            &--none {
                color: #ccc;
            }

            &--disabled {
                color: black;
            }
        }


    }

</style>